module.exports = __webpack_public_path__ + "static/media/smallSearch.d21bed30.svg";